<template>
  <div>
    <label
      v-if="!noLabel"
      :for="id"
      class="up"
    >{{ $attrs.label }}
      <span
        v-if="$attrs.required !== undefined && !noAsterisk"
        class="required"
      >*</span>
    </label>
    <ValidationProvider
      v-slot="{ errors, valid, validated }"
      :name="name"
      :rules="getValidation"
      slim
    >
      <b-form-radio-group
        :id="id"
        v-model="model"
        :class="{'is-invalid': !valid && validated}"
        :name="name"
        v-bind="$attrs"
        :options="options"
        :required="$attrs.required !== undefined"
        class="custom-radio"
        v-on="listeners"
      />
    </ValidationProvider>
  </div>
</template>

<script>
import basicComponentMixin from './basic-component-mixin.js'
export default {
  name: 'BasicRadio',
  mixins: [basicComponentMixin],
  props: {
    options: {
      type: Array,
      required: false,
      default: () => []
    },
    noAsterisk: {
      type: Boolean,
      default: false
    },
    noLabel: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  span.required {
    color: #9e0000;
  }
</style>
